import { Injectable, Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'searchfilter',
})

@Injectable()
export class SearchFilterPipe implements PipeTransform {
  transform(items: any[], field: string | Array<string>, value: string): any[] {
    const array = JSON.parse(JSON.stringify(items));
    if (!items) return [];
    if (!value) return array;

    if (typeof field === 'string') {
      return array.filter((it: any) => {
        it[field] = it[field] ? it[field] : '';
        return it[field].toLowerCase().indexOf(value.toLowerCase().trim()) !== -1;
      });
    } else {
      return array.filter((it: any) => {
        return field.some((el) => {
          it[el] = it[el] ? it[el] : '';
          return it[el].toLowerCase().indexOf(value.toLowerCase()) !== -1;
        });
      });
    }
  }
}
